<form #contextForm="ngForm">
  <div class="formgroup-inline justify-content-end">
    <div class="field">
      <label for="language">{{ 'Langue' | transloco }}</label>
      <p-dropdown id="language" [options]="languages" optionLabel="name" name="language" [(ngModel)]="selectedLanguage" (ngModelChange)="handleSelectedLanguageChangedEvent($event)"></p-dropdown>
    </div>
    <div class="field">
      <label for="contract">{{ 'Contrat' | transloco }}</label>
      <p-dropdown id="contract" [options]="contracts" optionLabel="libelle" name="contrat" [(ngModel)]="selectedContract" (ngModelChange)="handleSelectedContractChangedEvent($event)"></p-dropdown>
    </div>
  </div>
</form>
